import { render, staticRenderFns } from "./BottomNotification.vue?vue&type=template&id=069ac7b4&scoped=true"
import script from "./BottomNotification.vue?vue&type=script&lang=ts"
export * from "./BottomNotification.vue?vue&type=script&lang=ts"
import style0 from "./BottomNotification.vue?vue&type=style&index=0&id=069ac7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ac7b4",
  null
  
)

export default component.exports